import { Component, EventEmitter, Output } from '@angular/core'
import { closeJobSelectionDialog } from '../../../../shared/utils/job-selection-dialog-utils'
import {
    ClusteringNormalization,
    PipelineType,
    TsneParameters,
} from '../../../../shared/model/jobs'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'

@Component({
    selector: 'app-tsne-clustering-selection',
    templateUrl: './tsne-selection.component.html',
    styleUrls: ['./tsne-selection.component.scss'],
})
export class TsneSelectionComponent {
    ClusteringNormalizationValues = Object.values(ClusteringNormalization)

    readonly tsneForm: FormGroup

    readonly PERPLEXITY_FORM_KEY = 'perplexity'
    readonly LEARNING_RATE_FORM_KEY = 'learningRate'
    readonly NUMBER_OF_ITERATIONS_FORM_KEY = 'numberOfIterations'
    readonly RANDOM_INITIALIZATION_FORM_KEY = 'randomInitialization'
    readonly EXACT_GRADIENT_FORM_KEY = 'exactGradient'
    readonly NORMALIZATION_FORM_KEY = 'normalization'

    constructor(private readonly formBuilder: FormBuilder) {
        this.tsneForm = this.formBuilder.group({
            [this.PERPLEXITY_FORM_KEY]: new FormControl(30, [
                Validators.required,
                Validators.min(1),
            ]),
            [this.LEARNING_RATE_FORM_KEY]: new FormControl(200.0, [
                Validators.required,
                Validators.min(0),
            ]),
            [this.NUMBER_OF_ITERATIONS_FORM_KEY]: new FormControl(1000, [
                Validators.required,
                Validators.min(250),
            ]),
            [this.RANDOM_INITIALIZATION_FORM_KEY]: new FormControl(false, [Validators.required]),
            [this.EXACT_GRADIENT_FORM_KEY]: new FormControl(false, [Validators.required]),
            [this.NORMALIZATION_FORM_KEY]: new FormControl(ClusteringNormalization.None, [
                Validators.required,
            ]),
        })
    }

    @Output() paramsSet = new EventEmitter<TsneParameters>()

    get paramsValid(): boolean {
        return this.tsneForm.valid
    }

    get validationSummaryMessages(): string[] {
        const msgs: string[] = []
        const f = this.tsneForm

        const perplexityCtl = f.get(this.PERPLEXITY_FORM_KEY)
        if (perplexityCtl?.hasError('required')) {
            msgs.push('Enter perplexity.')
        } else if (perplexityCtl?.hasError('min')) {
            msgs.push('Perplexity must be at least 1.')
        }

        const lrCtl = f.get(this.LEARNING_RATE_FORM_KEY)
        if (lrCtl?.hasError('required')) {
            msgs.push('Enter learning rate.')
        } else if (lrCtl?.hasError('min')) {
            msgs.push('Learning rate must be at least 0.')
        }

        const iterationsCtl = f.get(this.NUMBER_OF_ITERATIONS_FORM_KEY)
        if (iterationsCtl?.hasError('required')) {
            msgs.push('Enter number of iterations.')
        } else if (iterationsCtl?.hasError('min')) {
            msgs.push('Number of iterations must be at least 250.')
        }

        return msgs
    }

    cancel(): void {
        closeJobSelectionDialog()
    }

    confirmParams(): void {
        if (!this.paramsValid) return

        this.paramsSet.emit({ type: PipelineType.tsneClustering, ...this.tsneForm.value })
    }
}
